import * as moment from 'moment'
import * as React from 'react'
import { Datepicker } from '@mobiscroll/react'

export interface IWorkingTimeProps {
  from: string
  type?: string
  until: string
  onTimeSet: (type: string, time: string) => void
}

const WorkingTime = ({ from, type, until, onTimeSet }: IWorkingTimeProps) => {
  const [inputValue, setInputValue] = React.useState<Date[] | null>(null)

  React.useEffect(() => {
    if (from !== '' && until !== '') {
      const formattedValue = [moment(from, 'HH:mm').toDate(), moment(until, 'HH:mm').toDate()]
      setInputValue(formattedValue)
    }
  }, [from, until])

  const handleTimeChanged = (value: Date[]) => {
    value.forEach((val: Date, index: number) => {
      const time = moment(val)
      const type = index === 0 ? 'from' : 'until'
      if (moment.isMoment(time)) {
        onTimeSet(type, time.format('HH:mm'))
      }
    })
  }

  return (
    <Datepicker
      controls={['time']}
      inputProps={{
        className: `${
          type === 'long' ? 'time-of-week-picker' : type === 'error' ? 'rounded p1 h4 mt02 border-red' : ''
        }`,
        style: {
          boxSizing: 'border-box',
          fontSize: '16px',
          width: '100%'
        }
      }}
      rangeEndLabel='Until'
      rangeStartLabel='From'
      select='range'
      stepMinute={15}
      timeFormat='hh:mm A'
      value={inputValue}
      onChange={({ value }) => handleTimeChanged(value)}
    />
  )
}

export default WorkingTime



// WEBPACK FOOTER //
// ./src/components/services/edit/WorkingTime.tsx